import Image from 'next/image';
import reebeloTextIcon from '@/public/icons/reebelo-text.svg';
import { BackButtonProps } from './types';
import chevronRightIcon from '@/public/icons/menu/chevron-right.svg';
import { shouldShowHolidays } from '@/lib/holidays';
import ChristmasHat from '@/public/icons/logo/christmas_hat.png';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const BackIcon = () => (
  <div className="h-[15px] w-[15px] shrink-0">
    <Image
      src={chevronRightIcon}
      height={14}
      width={14}
      alt="Expand"
      className="-mt-px h-full w-full rotate-180 transition-all duration-150 ease-in-out"
    />
  </div>
);

const BackButton = ({
  history,
  activeView,
  onBackToMainMenuClick,
  onBackToParentClick,
  onBackToMenuFromCountry,
  parentName,
}: BackButtonProps) => {
  if (activeView === 'country') {
    return (
      <button
        className="flex h-full w-full items-center gap-2 px-5 text-left outline-none hover:underline"
        onClick={onBackToMenuFromCountry}
      >
        <BackIcon />
        {t`Main Menu`}
      </button>
    );
  }

  if (history.length === 0) {
    return (
      <div className="flex h-full w-full items-center px-5">
        <div className="relative">
          {shouldShowHolidays && (
            <div className="absolute right-[-8px] top-[-6px] h-[30px] w-[30px] -scale-x-100 scale-y-100">
              <Image
                height={62}
                width={82}
                src={ChristmasHat}
                alt="Reebelo Christmas"
                className="h-full w-full cursor-pointer object-contain"
                priority
              />
            </div>
          )}
          <div className="h-5">
            <Image
              src={reebeloTextIcon}
              alt="Reebelo Text Logo"
              height={30}
              width={30}
              className="h-full w-auto"
            />
          </div>
        </div>
      </div>
    );
  }

  if (history.length === 1) {
    return (
      <button
        className="flex h-full w-full items-center gap-2 px-5 text-left outline-none hover:underline"
        onClick={onBackToMainMenuClick}
      >
        <BackIcon />
        {t`Main Menu`}
      </button>
    );
  }

  return (
    <button
      className="flex h-full w-full items-center gap-x-2 px-5 text-left outline-none hover:underline"
      onClick={onBackToParentClick}
    >
      <BackIcon />
      <div className="w-full truncate">{parentName}</div>
    </button>
  );
};

export default BackButton;
